import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

const FootnoteAnchor = styled('a')({
  textDecoration: 'none',
});

const namespace = 'c-footnote__p';

const FootnoteP = styled('p')({
  [`&.${namespace}`]: {
    fontSize: '0.6em',
    marginTop: 0,
    marginBottom: '3px',
    lineHeight: '1.5em',
  }
});

let sequence = 0;
export const Fn = ({prefix = '', n}) => (
  <sup>
    <FootnoteAnchor
      id={`c-footnote__${prefix}_${n}_`} href={`#c-footnote__${prefix}_${n}`}>({n})</FootnoteAnchor>
  </sup>
);

Fn.propTypes = {
  prefix: PropTypes.string,
  n: PropTypes.string.isRequired
};

export const Footnote = ({prefix = '', n, children}) => (
  <FootnoteP className={namespace}>
    <sup>
      <FootnoteAnchor
        id={`c-footnote__${prefix}_${n}`} href={`#c-footnote__${prefix}_${n}_`}>{n}</FootnoteAnchor>
    </sup>&nbsp;
    {children}
  </FootnoteP>
);

Footnote.propTypes = {
  prefix: PropTypes.string,
  n: PropTypes.string.isRequired
};


export const footnoteFactory = (FooterComponent = ({children}) => <div>{children}</div>) => {
    let notes = [];
    sequence++;
    return (note) => {
      if(note) {
        notes = [...notes, note];
        return (
          <Fn n={`${notes.length}`} prefix={`${sequence}`} />
        );
      } else {
        const oldNotes = notes;
        notes = [];
        return (
          <FooterComponent>{oldNotes.map((n, index) => (
                <Footnote key={index + 1} n={`${index + 1}`} prefix={`${sequence}`}>{n}</Footnote>))}
          </FooterComponent>
        );
      }
    };
};



// WEBPACK FOOTER //
// ./src/components/footnote/footnote.js